import LocationBlock from "./LocationBlock";

export default LocationBlock;
